export default function TECHNOLOGY() {
  
  const [w,l] = [window,location]

  w.load['header'].done(() => {
    $('.p-gnav li').currentMenu({item:'>a',mode:0,default:999})
  })

  // contentHeader
  {
    const id = l.search ? l.search.match(/article=(\d+)/)[1] : '1'
    const insertHtml = html => $('section.mainImg,h2.moduletitle').replaceWith(html)
    $.get(`/asset/html/head-technology-0${id}.html`).then((res,xhr,suc)=> {
      insertHtml(res)
      console.info(`%c/asset/html/head-technology-0${id}.html%c is loaded`,'font-weight: bold',res.url,'')
    })
  }

}